import React from 'react';
import { detailsPropTypes } from './DetailsPropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './Details.module.scss';
const Details = ({
  label,
  richtext
}) => {
  if (!label && !richtext) {
    return null;
  }
  return /*#__PURE__*/React.createElement("details", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("summary", {
    className: styles.rootSummary
  }, label, /*#__PURE__*/React.createElement(Icon, {
    name: "rankingTileDetailsArrowLg",
    size: {
      width: 20,
      height: 34
    },
    classname: styles.rootArrow
  })), richtext && /*#__PURE__*/React.createElement("div", {
    className: styles.rootContent,
    dangerouslySetInnerHTML: {
      __html: richtext
    }
  }));
};
export default Details;